import { createContext, useContext, useState } from 'react';

const SalesContext = createContext(null);

export const SalesProvider = ({ children }) => {
  const [leads, setLeads] = useState([]);
  const [loadingLeads, setLoadingLeads] = useState(new Set());
  const [activeLead, setActiveLead] = useState(null);
  const [filters, setFilters] = useState(() => {
    const storedFilters =
      typeof window !== "undefined" && localStorage.getItem("filters");
    return storedFilters
      ? JSON.parse(storedFilters)
      : {
        status: "",
        source: "rabbito",
        subscription: "",
      };
  });
  const [selectedTab, setSelectedTab] = useState("All Leads");
  const [selectedColumn, setSelectedColumn] = useState({ subscription: "Leads" });

  const value = {
    leads,
    setLeads,
    loadingLeads,
    setLoadingLeads,
    activeLead,
    setActiveLead,
    filters,
    setFilters,
    selectedTab,
    setSelectedTab,
    selectedColumn,
    setSelectedColumn
  };

  return (
    <SalesContext.Provider value={value}>
      {children}
    </SalesContext.Provider>
  );
};

export const useSales = () => {
  const context = useContext(SalesContext);
  if (!context) {
    throw new Error('useSales must be used within a SalesProvider');
  }
  return context;
};
